import React from 'react'

import { Img } from "./Elements";

export default function Ads({ v }) {
    return (
        <a href={v?.link} target={v?.link_type?.val} className='ads'> 
            <Img src={v?.ad}/>
        </a>
    )
}
